<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between" style="zoom: 0.85">
      <div>
        <div class="section-title">
          {{ $t("updatetransferStockRequestsLogs") }}
        </div>
      </div>
    </div>
    <br />
    <div class="white-wrapper">
      <!-- LIST VIEW DESIGNATION -->
      <table
        border="1"
        style="
          width: 100%;
          margin-bottom: 15px;
          border: 1px solid lightgray;
          font-size: 13px;
        "
      >
        <tbody>
          <tr style="vertical-align: top">
            <td style="width: 50%; padding: 5px">
              <tr class="request_details_tab">
                <div class="row w-100">
                  <div class="col-7">
                    <span class="font-weight-bold mr-1">Request Code:</span>
                  </div>
                  <div class="col-5">
                    <span class="">{{ requestDetails.request_code }} </span>
                  </div>
                </div>
              </tr>
              <tr class="request_details_tab">
                <div class="row w-100">
                  <div class="col-7">
                    <span class="font-weight-bold mr-1">Cinema Name:</span>
                  </div>
                  <div class="col-5">
                    <span class="">{{ requestDetails.cinema_name }} </span>
                  </div>
                </div>
              </tr>
              <tr class="request_details_tab">
                <div class="row w-100">
                  <div class="col-7">
                    <span class="font-weight-bold mr-1">Request Date:</span>
                  </div>
                  <div class="col-5">
                    <span class=""
                      >{{ requestDetails.request_date_time | dateparse }}
                    </span>
                  </div>
                </div>
              </tr>
            </td>
            <td style="padding: 5px">
              <tr class="request_details_tab">
                <div class="row w-100">
                  <div class="col-7">
                    <span class="font-weight-bold mr-1">Requested By:</span>
                  </div>
                  <div class="col-5">
                    <span class="">{{ requestDetails.requested_by }} </span>
                  </div>
                </div>
              </tr>
              <tr class="request_details_tab">
                <div class="row w-100">
                  <div class="col-7">
                    <span class="font-weight-bold mr-1">From Store:</span>
                  </div>
                  <div class="col-5">
                    <span class="">{{ requestDetails.from_store }} </span>
                  </div>
                </div>
              </tr>
              <tr class="request_details_tab">
                <div class="row w-100">
                  <div class="col-7">
                    <span class="font-weight-bold mr-1">To Store:</span>
                  </div>
                  <div class="col-5">
                    <span class="">{{ requestDetails.to_store }} </span>
                  </div>
                </div>
              </tr>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="swc-report">
        <caption class="text-nowrap font-weight-bold">
          Transfer Request Details:
        </caption>
        <table class="swc-report-table text-center" style="width: 100%">
          <tr class="lightBluebg">
            <th class="w400">Raw Material</th>
            <th>
              Qty. Avl
              <span v-if="request_logs.length"
                >( {{ request_logs[0].from_store }})</span
              >
            </th>
            <th>Qty. Requested</th>
            <th>Transfer Qty.</th>
            <th>Unit</th>
          </tr>

          <tbody v-if="request_logs && request_logs.length > 0">
            <tr v-for="(item, itemindex) in request_logs" :key="itemindex">
              <td class="text-left">{{ item.rm_name }}</td>
              <td class="text-right">
                {{ currFormat(item.current_store_quantity) || 0 }}
              </td>
              <td class="text-right">
                {{ currFormat(item.transfer_quantity_requested) || 0 }}
              </td>
              <td class="text-center">
                <input
                  class="transfer_qty_input"
                  name="transfer_qty_input"
                  id="transfer_qty_input"
                  type="number"
                  v-model="item.transfer_quantity"
                />
              </td>
              <td class="text-left">{{ item.uom_name || "-" }}</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="7">
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="row px-3 mt-4">
        <div class="d-flex align-items-center w-25">
          <div class="input-material-textarea">
            <textarea v-model="requestDetails['remarks']" rows="1"></textarea>
            <label :class="'shift-up'">{{ $t("remark") }}</label>
          </div>
        </div>
      </div>

      <div class="row px-3 mt-4">
        <div class="d-flex justify-content-center align-items-center w-100">
          <button
            class="btn btn-sm btn-primary mr-2 px-3"
            @click="onRequestConfirmation('approve')"
          >
            Approve
          </button>
          <button
            class="btn btn-sm btn-danger mr-2 px-3"
            @click="onRequestConfirmation('reject')"
          >
            Reject
          </button>
          <button
            class="btn btn-sm btn-outline-primary mr-2 px-3"
            @click="onCancelRequest()"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
    <b-modal
      id="reject_confirmation"
      title="Reject Stock transfer?"
      hide-footer
      no-close-on-backdrop
    >
      <div class="text-center pb-1">
        <p class="fs-16 mb-2">
          {{ `Are you sure you want to reject stock transfer` }}
        </p>

        <button
          class="btn-outline-blue"
          @click.prevent.stop="$bvModal.hide('reject_confirmation')"
        >
          Cancel
        </button>
        <span class="mx-1"></span>
        <button
          class="btn btn-danger btn-danger-lg px-4 fs-14"
          @click.prevent.stop="onRejectRequest"
        >
          Confirm
        </button>
      </div>
    </b-modal>

    <b-modal
      id="approve_confirmation"
      title="Approved Stock transfer?"
      hide-footer
      no-close-on-backdrop
    >
      <div class="text-center pb-1">
        <p class="fs-16 mb-2">
          {{ `Are you sure you want to transfer the stock?` }}
        </p>

        <button
          class="btn-outline-blue"
          @click.prevent.stop="$bvModal.hide('approve_confirmation')"
        >
          Cancel
        </button>
        <span class="mx-1"></span>
        <button
          class="btn btn-info btn-info-lg px-4 fs-14"
          @click.prevent.stop="onApproveRequest"
        >
          Confirm
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import PosFnbService from "@/services/PosFnbService";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    NoRecords,
  },
  data() {
    return {
      requestDetails: {
        request_id: null,
        request_code: null,
        cinema_name: null,
        cinema_id: null,
        request_date_time: null,
        from_store: null,
        to_store: null,
        requested_by: null,
        updated_user: null,
        remarks: null,
      },
      isRoleID: true,
      request_logs: [],
      request_logs_grouped: [],
      cinema_id: "",
      request_id: "",
    };
  },
  beforeMount() {
    const { request_id, cinema_id } = this.$route.query;

    if (!this.$can("update", "Stock Transfer Requests")) {
      this.$router.go(-1);
    }

    if (request_id && cinema_id) {
      this.cinema_id = cinema_id;
      this.request_id = request_id;
      this.getTransferRequests(request_id);
    } else {
      this.$router.go(-1);
    }
  },
  mounted() {},
  computed: {},
  methods: {
    onCancelRequest() {
      this.$router.push({
        path: "stocks-tranfer-requests",
      });
    },
    onRequestConfirmation(type = "approve") {
      if (type == "reject") {
        this.$bvModal.show("reject_confirmation");
      } else if (type == "approve") {
        this.$bvModal.show("approve_confirmation");
      }
    },
    onRejectRequest() {
      if (
        !this.requestDetails["request_id"] ||
        !this.requestDetails["cinema_id"]
      ) {
        this.$toasted.show("Unable to Reject. Please Reload & Try Again");
      } else {
        let loader = this.$loading.show();
        let payload = {
          request_id: this.requestDetails["request_id"],
          cinema_id: this.requestDetails["cinema_id"],
          remarks: this.requestDetails["remarks"],
          status: "Rejected",
        };
        PosFnbService.UpdateTransferStockRequest(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              this.$toasted.show(data.message || "Rejected");
              this.$router.push({
                path: "stocks-tranfer-requests",
              });
            } else {
              this.$toasted.show(data.message || "Failed");
            }
          })
          .finally(() => {
            loader.hide();
          });
      }
    },
    validateRequest() {
      let errorCount = 0;
      let errorMsg = "";

      this.request_logs.forEach((_item) => {
        if (isNaN(String(_item["transfer_quantity"]))) {
          errorCount++;
          errorMsg = "Invalid Transfer Qty";
        }
      });

      if (errorCount > 0) {
        this.$toasted.show(errorMsg);
        return false;
      } else {
        return true;
      }
    },
    onApproveRequest() {
      const isValid = this.validateRequest();
      if (
        !this.requestDetails["request_id"] ||
        !this.requestDetails["cinema_id"]
      ) {
        this.$toasted.show("Unable to Reject. Please Reload & Try Again");
      } else if (!isValid) {
        return false;
      } else {
        let loader = this.$loading.show();
        let payload = {
          request_id: this.requestDetails["request_id"],
          cinema_id: this.requestDetails["cinema_id"],
          remarks: this.requestDetails["remarks"],
          request_items: this.request_logs,
          status: "AWC",
        };
        PosFnbService.UpdateTransferStockRequest(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              this.$toasted.show(data.message || "Rejected");
              this.$router.push({
                path: "stocks-tranfer-requests",
              });
            } else {
              this.$toasted.show(data.message || "Failed");
            }
          })
          .finally(() => {
            loader.hide();
          });
      }
    },
    onApproveTransfer() {},
    getTransferRequests: function (request_id) {
      if (!request_id) {
        return this.$toasted.show("Invalid Request.Please reload & Try Again");
      } else {
        let loader = this.$loading.show();
        let payload = {
          cinema_id: this.cinema_id,
          request_id: request_id,
        };
        PosFnbService.GetTranferRequestById(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records && data.Records.length > 0) {
              this.request_logs = data.Records;
              Object.keys(this.requestDetails).map((key) => {
                this.requestDetails[key] =
                  data.Records[0][key] || this.requestDetails[key];
              });
              this.request_logs_grouped = data.groupedData;
            } else {
              this.request_logs = [];
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError)
          .finally(() => {
            setTimeout(() => loader.hide(), 1000);
          });
      }
    },
  },
};
</script>

<style scoped>
.swc-report-table th,
.swc-report-table td {
  border: 1px solid #c7c6c6;
}

.showBorder-down {
  border: 1.5px solid black;
  border-top: 0;
}

.lightBluebg {
  background: #e2ecfc;
}

.request_details_tab {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 50%;
  white-space: nowrap;
  padding-bottom: 3px;
  text-transform: uppercase;
}

.transfer_qty_input {
  border: 1px solid lightgray;
  border-radius: 3px;
  text-align: center;
  width: 100%;
}

.w400 {
  width: 400px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/TransferStocks/editTransferRequest.vue